export default class {
  constructor() {
    this.selector = '.js-slider-gallery';
  }

  init() {
    $(() => {
      import('slick-carousel').then(() => {
        $(this.selector).slick({
          arrows: false,
          dots: false,
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: true,
          centerMode: false,
          autoplaySpeed: 5000,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: false,
              },
            },
            {
              breakpoint: 566,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
                arrows: false,
              },
            },
          ],
        });
        $(this.selector).on("lazyLoaded", function lazy(e, slick, image) {
          const parentSlide = $(image).parent(".photo-bg");
          parentSlide.css("background-image", `url(${image.attr("data-lazy")})`).addClass("loaded");
          image.remove();
        });
      });
    });
  }
}
